import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

const EmployeeResponsibilities: React.FC = () => {
  const responsibilities = [
    "Adesão às normas internas: Ler, compreender e cumprir integralmente as disposições previstas na Política de Privacidade e Proteção de Dados, bem como em demais normas e diretrizes relacionadas ao tema, sem exceções;",
    "Atualização de dados pessoais: Manter suas informações pessoais devidamente atualizadas junto à empresa, contribuindo para a correta gestão de dados pessoais;",
    "Promoção da cultura de privacidade: Adotar uma postura proativa e colaborar na disseminação da cultura de privacidade e segurança de dados promovida pela INNOVA PLANO DE SAÚDE;",
    "Observância contratual: Respeitar e cumprir as cláusulas previstas no contrato de trabalho que tratem do tratamento e proteção de dados pessoais;",
    "Cumprimento de responsabilidades assumidas: Seguir rigorosamente as disposições contidas nos termos e compromissos assumidos perante a INNOVA PLANO DE SAÚDE;",
    "Identificação de riscos: Reportar quaisquer riscos relacionados à proteção de dados pessoais ao Encarregado de Proteção de Dados (Data Protection Officer – DPO);",
    "Notificação de incidentes: Informar de forma imediata ao Encarregado de Proteção de Dados qualquer evento ou incidente que possa representar uma violação desta Política de Privacidade ou das normas de proteção de dados aplicáveis."
  ];

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        9. Responsabilidades dos Colaboradores da INNOVA PLANO DE SAÚDE
      </Typography>

      <Typography paragraph>
        No exercício de suas funções, os colaboradores da INNOVA PLANO DE SAÚDE LTDA têm as seguintes responsabilidades, em conformidade com a legislação aplicável e as políticas internas da empresa:
      </Typography>

      <List>
        {responsibilities.map((responsibility, index) => (
          <React.Fragment key={index}>
            <ListItem>
              <ListItemText primary={responsibility} />
            </ListItem>
            {index < responsibilities.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>

      <Typography paragraph>
        O não cumprimento das responsabilidades acima descritas poderá acarretar medidas disciplinares, conforme previsto no contrato de trabalho e na legislação vigente.
      </Typography>
    </div>
  );
};

export default EmployeeResponsibilities;
